
import React, {useEffect, useRef, useState} from "react";
import {FormOutlined, DeleteOutlined, SearchOutlined, PlusOutlined, QuestionCircleOutlined,ExportOutlined} from "@ant-design/icons";
import {Breadcrumb, Button, Divider, message, Modal, Popconfirm, Popover, Space, Tag} from "antd";
import MyProLayout from "../../components/MyProLayout";
import {ActionType, ProTable} from "@ant-design/pro-components";
import FetchUtil from "../../utils/FetchUtil";
import AiGameLogs from "./AiGameLogs";
import AiGameKeys from "./AiGameKeys";
import StringUtil from "../../utils/StringUtil";
import AiGameDomain from "./AiGameDomain";


const DomainIndex = (prop: any) => {

    const actionRef = useRef<ActionType>();
    const logsRef = useRef();
    const keysRef = useRef();
    const domainRef = useRef();

    useEffect(() => {
    }, []);

    const openKeys = (id: number) => {
        (keysRef.current as any).openEditor(id);
    }
    const openDomain = (domain: string) => {
        (domainRef.current as any).openEditor('', domain);
    }

    const columns: any[] = [
        {
            title: "域名",
            dataIndex: "domain",
            width: 100,
        },
        {
            title: "覆盖游戏",
            dataIndex: "gameCount",
            width: 100,
        },
        {
            title: '更新日期',
            dataIndex: 'updateTime',
            align: 'center' as 'center',
            width: 100,
            valueType: "date"
        },
        {
            title: "游戏",
            dataIndex: '_domain',
            align: 'center' as 'center',
            width: 100,
            hideInSearch: true,
            render: (v: any, r:any) => <a onClick={() => openDomain(r.domain)}>域名</a>
        },

    ];

    return (
        <MyProLayout>
            <ProTable
                rowKey={"id"}
                search={{span: 5}}
                actionRef={actionRef}
                columns={columns}
                cardBordered={true}
                request={async (
                    params,
                    sort,
                    // filter,
                ) => {
                    let orderBy = "game_count desc"
                    for (const key in sort) {
                        orderBy = StringUtil.camelToSnake(key) + " "
                        orderBy += sort[key] === "descend" ? "desc" : "asc"
                    }
                    const query: any = {
                        query: {...params},
                        page: {
                            pageNo: params.current,
                            pageSize: params.pageSize,
                            orderBy: orderBy // params.orderBy ? params.orderBy : sortEnum[0].value
                        }
                    }
                    const res = await FetchUtil.awaitFetch('/mallApi/aiGame/domainIndex', query);
                    console.log(res)
                    return {
                        success: true,
                        data: res.data.list,
                        total: res.data.total,
                    };
                }}
            />
            <AiGameKeys ref={keysRef} />
            <AiGameLogs ref={logsRef} />
            <AiGameDomain ref={domainRef} />

        </MyProLayout>
    );
}

export default DomainIndex;
